import { render, staticRenderFns } from "./MercadosPage.html?vue&type=template&id=36fa430f&external"
import script from "./MercadosPage.vue?vue&type=script&lang=ts"
export * from "./MercadosPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports